import React from 'react';
import styled from 'styled-components';

import appStoreImg from '../assets/images/app-store-badge.png';
import googlePlayImg from '../assets/images/google-play-badge.png';

const ButtonsContainer = styled.ul`
	display: flex;
	list-style-type: none;

	> *:not(:last-child) {
		margin-right: 10px;
	}

	@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
		justify-content: center;

		> * {
			margin: 0;
		}
	}
`;
const Button = styled.a`
	display: inline-block;
	height: 50px;

	img {
		width: 100%;
		max-width: 180px;
	}
`;

const StoreButtons = () => {
	return (
		<ButtonsContainer>
			<li>
				<Button
					href="https://itunes.apple.com/us/app/biddl/id1022341873?ls=1&amp;mt=8"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img src={appStoreImg} alt="Download on the App Store" />
				</Button>
			</li>
			<li>
				<Button
					href="https://play.google.com/store/apps/details?id=com.biddl.biddl"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img src={googlePlayImg} alt="Get it on Google Play" />
				</Button>
			</li>
		</ButtonsContainer>
	);
};

export default StoreButtons;



// WEBPACK FOOTER //
// ./src/components/StoreButtons.js